<template>
    <div class="app-index">
        <div class="container d-flex justify-content-center">
            <div class="form-material mt-5">
                <div>
                    <!--img src="@/img/LOGO_NUBBO_FINAL-02.png" width="250"-->
                </div>
                <div class="form-group form-default">
                    <input type="text" class="form-control" :class="{'fill': username}" id="username" name="username" v-model="username"/>
                </div>
                <div class="form-group form-default">
                    <input type="password" class="form-control" :class="{'fill': password}" id="password" name="password" v-model="password"/>
                </div>
                <div class="d-flex justify-content-center">
                    <button id="submit" @click="login" class="btn btn-primary w-100" :disabled="processing">
                        <span v-if="!processing">{{'Sign in'}}</span>
                        <img class="processing-gif" src="@/assets/img/loading.gif" v-else>
                    </button>
                </div>
                <div class="form-group d-flex justify-content-center">
                    <label v-if="error" class="alert alert-danger" role="alert">
                        {{ error }}
                    </label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

const api = window.api;
export default {
    name: 'SayLogin',
    data () {
        return {
            processing: false,
            username: null,
            password: null,
            error: null,
            msg: null,
        }
    },
    computed: {
        user () {
            return this.$store.state.user;
        }
    },
    mounted () {
        if (this.user) {
            this.$router.push({name: 'FIT'});
            return
        }
        this.$store.commit("setUser", null);
    },
    methods: {
        handleError (response) {
            this.error = response;
        },
        async login () {
            this.error = null;
            var data = new FormData();
            data.append('username', this.username);
            data.append('password', this.password);
            let res = await api.post('/api/login', data, {}, this.handleError)
            if (res) {
                await api.getCurrentUser()
                this.$router.push({name: 'Home'})
                this.$store.commit('setUser', res);
            }
        },
    },
}
</script>

